import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiError } from '@/modules/common/hooks/use-api-error';

import { createElement } from '../api/reports.api';
import { REPORT_DETAIL_QUERY_KEY } from '../constants/reports-query-keys';

export const useCreateElement = () => {
  const queryClient = useQueryClient();
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: ({
      reportId,
      type,
      position,
      config,
      reportType,
      columns,
      groupBy,
      pivotDimension,
      customMeasures,
      localFilters,
    }: {
      reportId: string;
      type: string;
      position: { x: number; y: number; width: number; height: number };
      config: Record<string, unknown>;
      reportType?: string;
      columns?: string[];
      groupBy?: string[];
      pivotDimension?: string | null;
      customMeasures?: unknown[];
      localFilters?: unknown[];
    }) =>
      createElement(reportId, {
        type,
        position,
        config,
        reportType,
        columns,
        groupBy,
        pivotDimension,
        customMeasures,
        localFilters,
      }),
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: REPORT_DETAIL_QUERY_KEY(data.id) });
    },
    onError: error => {
      displayToastErrorFromApiWithFallback(
        error,
        'authenticated.reports:toasts.elementCreateError'
      );
    },
  });
};
